// environment-checks.ts
var Environment = /* @__PURE__ */ ((Environment2) => {
  Environment2["NODE"] = "node";
  Environment2["SERVICEWORKER"] = "serviceworker";
  Environment2["BROWSER"] = "browser";
  Environment2["ELECTRON"] = "electron";
  Environment2["UNKNOWN"] = "unknown";
  return Environment2;
})(Environment || {});
var testElectron = () => typeof process === "object" && typeof process.version === "object" && process.versions.hasOwnProperty("electron");
var testBrowser = new Function("try { return this===window; } catch(e) { return false; }");
var testServiceWorker = new Function(
  "try { return self instanceof ServiceWorkerGlobalScope; } catch(e) { return false; }"
);
var testNode = () => typeof process === "object" && typeof process.versions === "object" && typeof process.versions.node !== "undefined";
var getEnvironment = () => testElectron() ? "electron" /* ELECTRON */ : testNode() ? "node" /* NODE */ : testServiceWorker() ? "serviceworker" /* SERVICEWORKER */ : testBrowser() ? "browser" /* BROWSER */ : "unknown" /* UNKNOWN */;
export {
  Environment,
  getEnvironment
};
